#import "../../../timeline/graphql/fragments/activity-fragment.graphql"

mutation SaveTranscriptSummary($input: TranscriptSummarySaveInput!) {
    transcriptSummarySave(input: $input) {
        activity {
            ...ActivityFragment
        }
    }
}
